import React from 'react';

const FinalCTA = () => {
  return (
    <section className="py-32 bg-background relative overflow-hidden" data-testid="final-cta-section">
      <div className="relative z-10 max-w-container-max mx-auto px-margin-desktop text-center">
        <h2 className="font-display-lg text-display-lg text-primary mb-8">Ready to Scale Your Business?</h2>
        <p className="font-body-lg text-body-lg text-on-surface-variant mb-12 max-w-2xl mx-auto">
          Join thousands of businesses already growing with AI precision. Start your free trial today.
        </p>
        <a
          href="/signup"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-primary text-on-primary px-12 py-5 rounded-xl font-headline-md font-bold hover:scale-105 transition-transform no-underline"
          style={{ boxShadow: '0 0 50px rgba(255,255,255,0.15)' }}
          data-testid="final-cta-btn"
        >
          Get Started Now
        </a>
      </div>
    </section>
  );
};

export default FinalCTA;
